import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagTbTest = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 20,
	viewBox: "0 0 20 20",
	width: 20,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		clipRule: "evenodd",
		fill: "current",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "m6.46614 4.44336c-3.01847 0-5.46614 2.44699-5.46614 5.46464v4.0476c0 .7825.63468 1.417 1.41741 1.417h4.04873c.78272 0 1.41741-.6345 1.41741-1.417v-8.09522c0-.7825-.63467-1.41702-1.41741-1.41702z" }),
			/* @__PURE__ */ _jsx("path", { d: "m13.3482 4.80176c-.8092 0-1.4654.61373-1.4654 1.37062v7.83022c0 .7569.6562 1.3706 1.4654 1.3706h4.1858c.8092 0 1.4654-.6137 1.4654-1.3706v-3.9151c0-2.91886-2.5306-5.28574-5.6512-5.28574z" }),
			/* @__PURE__ */ _jsx("path", { d: "m10.0009 3c.3469 0 .6279.26281.6279.5873v3.62219l2.2667 1.63051c.2747.19821.3265.56674.1146.82369-.2112.25695-.6052.3054-.8807.10718l-2.1286-1.53139-2.12867 1.53139c-.27471.19822-.6695.14976-.88064-.10718-.21113-.25695-.16011-.62548.1146-.82369l2.26669-1.63051v-3.62219c0-.32449.28118-.5873.62812-.5873z" })
		]
	})
});
export default SvgFlagTbTest;
